<template>
  <Navbar :rightBtn="true" :title="'服务机构'"></Navbar>
  <div class="header flex">
    <!-- <div class="open-box" @click="togglerSider">
      <img src="@/assets/images/mall/icon_4@2x.png" alt="">
      分类
    </div> -->
    <!-- <div class="hr"></div> -->
    <div class="search-box flex-item">
      <input ref="searchInput" type="text" v-model="keyword" placeholder="搜索" confirm-type="search" @keyup.enter.native="goSearch" @confirm="goSearch">
      <span class="icon-search" @click="goSearch"></span>
    </div>
  </div>
  <div class="warp-box">
    <van-sidebar class="sidebar" v-model="active" v-if="openSider" @change="changeSidebar">
      <van-sidebar-item v-for="item in sidebarList" :key="item" :title="item.name" />
    </van-sidebar>
    <div class="content">
<!--
      <coupon-ad :openSider="openSider"></coupon-ad>
-->
      <van-empty description="暂无数据" v-show="emptyShow" />
      <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="getData" v-if="!emptyShow">
        <div class="policy-file-item flex" :class="{ 'has-sider': openSider }" v-for="record in list" :key="record"
          @click="goDetail(record)">
          <div class="img-box">
            <img v-lazy="record.avatar" alt="" v-if="record && record.avatar" />
            <img src="@/assets/images/mall/img_d.jpg" alt="" v-else />
            <!-- <div class="vip-img"></div>
            <div class="vip-box">
              <div class="txt"> 折扣<span>{{ record.discount }}</span>折</div>
            </div> -->
          </div>
          <div class="flex-item">
            <div class="policy-file-item-content" style="display:flex">
              <div class="policy-file-item-title title_2">{{ record.name }}</div>
            </div>
            <div class="policy-file-item-footer">
              <div>
                <!-- <div class="company">
                  <img style="height:15px;width:15px" src="@/assets/images/group1.svg" alt="">
                  {{ record.name }}
                </div> -->
                <div class="flex">
                  <div class="flex-item">
                     <img style="height:15px;width:15px;vertical-align: middle;" src="@/assets/images/group2.svg" alt="">
                    阅读量:{{ record.click_num }}
                  </div>
                </div>
                <div class="flex">
                  <div class="flex-item">
                    <img style="height:15px;width:15px;vertical-align: middle;" src="@/assets/images/group3.svg" alt="">
                    已办理{{ record.handle_num }}件
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </van-list>
    </div>
  </div>
</template>

<script>
import { getServiceProviderList } from '@/api/home'
import { clickUrl } from '@/utils'
import CouponAd from '../../components/CouponAd.vue'
import Navbar from '@/components/Navbar'
export default {
  data() {
    return {
      openSider: false,
      active: '0',
      sidebarList: [
        { name: '全部', sn: '', },
        { name: '政策申报', sn: 'policy_declare_flag', },
        { name: '知识产权', sn: 'intellectual_property_flag', },
        { name: '财税咨询', sn: 'tax_onsulting_flag', },
        { name: '法律法务', sn: 'law_flag', },
      ],
      list: [],
      keyword: '',
      industry: '',
      loading: false,
      finished: false,
      emptyShow: false,
      page:{
        count: 0,
        size: 20,
        total: 0
      },
    }
  },
  components: { CouponAd,Navbar },
  watch: {},
  mounted() {},
  methods: {
    goSearch() {
      // this.$refs.searchInput.blur()
      this.active = '0'
      this.industry = ''
      this.page.count = 0
      this.list = []
      this.getData()
    },
    togglerSider() {
      this.openSider = !this.openSider
    },
    changeSidebar(val) {
      this.industry = this.sidebarList[val].name == '全部' ? '' : this.sidebarList[val].sn
      this.keyword = ''
      this.page.count = 0
      this.list = []
      this.getData()
    },
    async getData() {
      this.page.count += 1
      this.loading = true
      let params = {
        type: this.industry,
        keywords: this.keyword,
        page: this.page.count,
        pageSize: this.page.size,
      }
      
      try{
        let res = await getServiceProviderList(params)
        let list = res.result.data || []
        this.list = this.list.concat(list)
        this.page.total = res.result.total
        this.finished = this.list.length >= res.result.total && res.result.total != 0 ? true : false
        this.emptyShow = !res.result.total ? true : false
      }
      catch {}
      finally{
        this.loading = false
      }
    },
    goDetail(item) {
      clickUrl('/mall/detail',{ id:item.id, title: '服务机构信息', btnType: '1' })
    },
    goCouponUseDetail(){
       clickUrl('/coupon/use_detail')
    }
  }
}
</script>
<style lang="scss" scoped>
.header {
  height: 32px;
  background: #fff;
  padding: 6px;

  .open-box {
    width: 89px;
    height: 100%;
    text-align: center;
    font-size: 14px;
    line-height: 32px;

    img {
      width: 19px;
      height: 16px;
      background-size: contain;
      vertical-align: middle;
      margin-right: 5px;
    }
  }

  .hr {
    width: 1px;
    height: 20px;
    background: #D5E6F4;
    margin: 6px 20px;
  }

  .search-box {
    height: 32px;
    background: rgba(202, 214, 223, 0.5);
    border-radius: 26px;
    border: 1px solid #FFF;
    position: relative;

    input {
      width: 78%;
      height: 30px;
      background: transparent;
      border: 0;
      margin: 0 13px;
    }

    .icon-search {
      display: inline-block;
      width: 20px;
      height: 20px;
      position: absolute;
      top: 6px;
      right: 13px;
      background: url('../../assets/images/vector@2x.png') no-repeat center center;
      background-size: contain;

    }
  }
}

.warp-box {
  display: flex;
  flex-flow: row;
  flex-shrink: 0;
  height: calc(100vh - 95px);
  overflow: hidden;
  .content {
    width: 100%;
    height: 100%;
    overflow: scroll;
  }
}

.sidebar {
  flex-shrink: 0;
  width: 80px;
  height: calc(100vh - 44px);
  background: #FAFAFA;
  box-shadow: 2px 0px 8px 1px rgba(26, 119, 233, 0.15);
}

.flex {
  display: flex;
  flex-flow: row;

  .flex-item {
    flex: 1;
  }
}

.content {
  font-size: 12px;

  .policy-file-item {
    padding: 15px 3px 15px 12px;
    margin: 0 10px 15px;
    border-radius: 6px;
    box-shadow: 0px 4px 4px 1px rgba(43, 48, 51, 0.15);

    // &.has-sider {
    //   margin-right: 0;
    // }
  }

  .img-box {
    width: 73px;
    height: 73px;
    border-radius: 6px;
    position: relative;
    margin-right: 5px;

    img {
      width: 100%;
      height: 100%;
      background-size: 100% 100%;
      border-radius: 6px;
    }

    .vip-img {
      position: absolute;
      z-index: 10;
      bottom: 0;
      left: -13px;
      width: 90px;
      height: 21px;
      background: url('../../assets/images/mall/icon_vip@2x.png') no-repeat center center;
      background-size: cover;
      z-index: 1;
    }

    .vip-box {
      position: absolute;
      z-index: 5;
      bottom: 0;
      left: 0;
      width: 60px;
      height: 14px;
      color: #fff;
      text-align: center;
      line-height: 14px;
      padding-left: 7px;
      font-size: 12px;

      .txt {
        transform: scale(0.8);
        white-space: nowrap;
      }

      span {
        color: #FF0000;
        font-size: 14px;
        font-weight: 600;
        margin: 0 3px;
      }
    }
  }

  .policy-file-item-content {
    padding: 0;
    margin: 0;
  }

  .policy-file-item-footer {
    padding: 8px 0 0;
    border: 0;

    >div {
      width: 100%;
    }
  }

  .policy-file-item-title {
    font-size: 14px;
    margin-bottom: 8px;
    background: rgb(255, 255, 255) !important;
    padding: 0px;
    justify-content: left;
  }

  .icon-box {
    display: inline-block;
    width: 15px;
    height: 15px;


    &.icon-1 {
      background: url('../../assets/images/mall/icon_3@2x.png') no-repeat center center;
      background-size: contain;
    }

    &.icon-2 {
      background: url('../../assets/images/mall/icon_2@2x.png') no-repeat center center;
      background-size: contain;
    }

    &.icon-3 {
      background: url('../../assets/images/mall/icon_1@2x.png') no-repeat center center;
      background-size: contain;
    }
  }



}

.title_2 {
  overflow: hidden;
  text-overflow: ellipsis; // text-overflow css3的属性，当文本溢出时，显示省略号
  display: -webkit-box;
  -webkit-line-clamp: 2; // 设置两行文字溢出
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.coupon-box{
  margin: 15px 10px 0 7px;
}
</style>
